import { render, staticRenderFns } from "./CChartLineSimple2.vue?vue&type=template&id=c22bf8da&"
import script from "./CChartLineSimple2.vue?vue&type=script&lang=js&"
export * from "./CChartLineSimple2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports